


export class ProfilePublicationView {
    constructor() {

        this.template = document.querySelector('#publication-template');
        this.container = document.querySelector('#publications-list');
    }

    render(state) { 

        if (!(state && Object.keys(state).length > 0)) { return;}

        const data = state.data;

        const section = document.querySelector('section.sc_publications');
        if (section) {

            const title = section.querySelector('div.sc_title strong');
            if (title) { title.textContent = data.title;}

            const count = section.querySelector('div.sc_title em');
            if (count) { count.textContent = data.totalCount;}

            

            const url = section.querySelector('a.sc_header');
            if (url) {

                url.href = data.url;

                if (data.totalCount > 9) {
                    const more = url.querySelector('div.sc_more');
                    if (more) { more.style.display = '';}
                }
            }
        }

        if (!data.models.length) {

            section.classList.add('empty');
            section.querySelectorAll('div.ul .li').forEach(el => el.remove());

            const emptyBody = section.querySelector('.sc_body_empty');
            if (emptyBody && data.addUrl != false) {

                const addLink = document.createElement('a');
                addLink.classList.add('add_button');
                addLink.textContent = data.addUrl.tip;
                addLink.href = data.addUrl.url;
                emptyBody.appendChild(addLink);
            }

            emptyBody.style.display = '';


            return;
        }


        const container = this.container;
        let next = container.nextElementSibling;

        data.models.forEach((model, index) => {
            
            const p = this.renderPartial(model);

            if (index < 8) {

                const current = next;
                if (next != null) { next = next.nextElementSibling;}

                if (
                    current &&
                    current.classList.contains('li') &&
                    current.querySelector('.dummy')
                ) {

                    current.replaceChildren(p)

                } else {

                    const div = document.createElement('div');
                    div.classList.add('li');
                    div.appendChild(p);

                    const liAfterPublications = document.querySelectorAll('#publications-list ~ .li');
                    const lastPublication = liAfterPublications[liAfterPublications.length - 2];

                    lastPublication.after(div);
                }
            } else if (index === 8 && data.models.length > 9) {

                const more = container.parentElement.querySelector('div.stub_more').parentElement;
                more.style.display = '';
            }
        });

        container.parentElement.querySelectorAll('div.ul .li').forEach(el => {

            const dummyArticle = el.querySelector('article.dummy');
            if (dummyArticle) { el.remove();}
        });
    }

    renderPartial(data) {

        const p = this.template.content.cloneNode(true);
        const article = p.querySelector('article.publication');
        if (article) {

            article.classList.remove('dummy');

            article.id = 'publication' + data.id;
            article.dataset.id = data.id;

            const preview = article.querySelector('a.preview');
            if (preview) {

                preview.href = data.url;

                const img = preview.querySelector('img');
                if (img) {
                    img.src = data.preview;
                    img.dataset.src = data.preview;
                }
            }

            const authorBlock = p.querySelector('.h');
            if (authorBlock) {

                const profileLink = authorBlock.querySelector('a');
                if (profileLink) {
                    profileLink.href = data.author.url;
                }

                const avatar = authorBlock.querySelector('img');
                if (avatar) {
                    avatar.src = data.author.avatar;
                    avatar.alt = data.author.username;
                }

                const username = authorBlock.querySelector('span');
                if (username) {
                    username.textContent = data.author.username;
                }

                const date = authorBlock.querySelector('.date');
                if (date) {
                    date.textContent = data.date;
                }
            }

            const title = article.querySelector('div.title a');
            if (title) {

                title.href = data.url;
                title.textContent = data.title;
            }

            const ulContainer = p.querySelector('.post_tags .ul');
            if (ulContainer) {

                if (data.categories.length) {

                    const cat = ulContainer.querySelector('div.cat');
                    cat.dataset.id = data.categories[0].id;

                    const link = cat.querySelector('a');
                    if (link) {
                        link.href = data.categories[0].url;

                        const catTitle = link.querySelector('span');
                        if (catTitle) {
                            catTitle.textContent = data.categories[0].title;
                        }
                    }
                }

                if (data.tags.length) {

                    data.tags.forEach(tag => {

                        const div = document.createElement('div');
                        div.classList.add('li');

                        const a = document.createElement('a');
                        a.href = tag.url;

                        const span = document.createElement('span');
                        span.textContent = tag.title;

                        a.appendChild(span);
                        div.appendChild(a);

                        ulContainer.appendChild(div);
                    });
                }
            }

            const announce = p.querySelector('.anno');
            if (announce) { announce.textContent = data.announce;}

            const counters = p.querySelector('.counters');
            if (counters) {
                const like = counters.querySelector('.ci.like span');
                if (like && data.counters?.likes) {
                    like.textContent = data.counters.likes.value;
                    if (data.counters.likes.isActive) {
                        counters.querySelector('.ci.like').classList.add('toggled');
                    }
                }

                const comments = counters.querySelector('.ci.comments span');
                if (comments && data.counters?.comments) {
                    comments.textContent = data.counters.comments.value;
                    const commentLink = counters.querySelector('.ci.comments a');
                    if (commentLink) { commentLink.href = data.url + '#comments';}
                }

                const views = counters.querySelector('.ci.views span');
                if (views && data.counters?.views) {
                    views.textContent = data.counters.views.value;
                }
            }
        }

        return p.firstElementChild;
    }
}